import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store';
import AuthLayout from '../../../../layouts/AuthLayout';
import { Box, Button, Typography } from '@mui/material';
import { DMUKLogo, Loader, SplashBox } from '@omnigenbiodata/ui';
import { Link } from 'react-router-dom';
import ROUTES from '../../../../core/constants/routes.constants';
import { registerSampleInterestThunk } from '../../../../store/user/thunks';
import { hasSuccessSelector, isBusySelector } from '../../../../store/user';
import { useTranslation } from 'react-i18next';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';

function ConfirmSampleKit() {
  const { t } = useTranslation('portal');
  const [token, setToken] = useState('');
  const response = useAppSelector(hasSuccessSelector);
  const isBusy = useAppSelector(isBusySelector);
  const dispatch = useAppDispatch();

  const submitConfirm = () => {
    dispatch(
      registerSampleInterestThunk({
        identifier: token,
      }),
    );
  };

  useEffect(() => {
    const _token = new URLSearchParams(location.search).get('token') || '';
    setToken(_token);
  }, [dispatch]);

  return (
    <AuthLayout>
      <SplashBox>
        <Box mb={2} mt={5} textAlign="center">
          <Link to={ROUTES.root}>
            <DMUKLogo size="xs" />
          </Link>
        </Box>
        {!response && (
          <>
            <Box mt={3} mb={3} pl={2} pr={1}>
              <Typography variant="h5" component="h4" align="center" gutterBottom fontWeight="bold">
                {t('confirmSalivaKit.title')}
              </Typography>
            </Box>
            <Box mb={3} pl={2} pr={1}>
              <Typography paragraph variant="body1" align="center">
                {t('confirmSalivaKit.descriptionParagraph1')}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center" width="100%">
              <Button
                size="large"
                data-testid="confirm-button"
                fullWidth
                variant="contained"
                style={{ background: '#316610' }}
                onClick={submitConfirm}
              >
                {t('confirmSalivaKit.confirmButton')}
              </Button>
            </Box>
          </>
        )}
        <Loader data-testid="loader" isVisible={isBusy} label={t('loaders.waiting') as string} />
        {response && (
          <>
            <Box sx={{ mt: 2 }} pl={2} pr={2}>
              <TaskAltOutlinedIcon
                color="success"
                sx={{ fontSize: 50, display: 'block', margin: '0 auto', marginBottom: '10px' }}
              />
              <Typography paragraph align="center" variant="body1" fontWeight="bold">
                {t('confirmSalivaKit.successMessage')}
              </Typography>
              <Typography paragraph align="center" variant="body1">
                {t('confirmSalivaKit.successMessage2')}
              </Typography>
            </Box>
            <p></p>
          </>
        )}
      </SplashBox>
    </AuthLayout>
  );
}

export default ConfirmSampleKit;
